import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSalesContractDetail as getSalesContractDetailApi } from "../../helpers/ServiceHelpers/backend_helper";

export const getSalesContractDetail = createAsyncThunk(
  "contracts/getSalesContractDetail",
  async (data: {
    sellerId: any;
    isOnlineSeller: any;
    skip: number;
    take: number;
  }) => {
    try {
      const response = await getSalesContractDetailApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
